import React from 'react'

import { LntModal } from '@app/components/base'

import styles from './styles.module.scss'

import type { RecoveryTasksItemsModalProps } from './types'

export const CommonTasksItemsModal: React.FC<RecoveryTasksItemsModalProps> = props => {
  const { onSubmit, title, ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      className={ styles.commonTasksItemsModal }
      title={ title }
      onOk={ onSubmit }
    />
  )
}
